// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table-container {
  width: 100%;
  background: var(--m-card-background-color, white);
  border-radius: 8px;
  box-shadow: var(--m-box-shadow, 0 1px 3px rgba(0, 0, 0, 0.1));
  overflow: hidden;
  position: relative;
  z-index: 0;
}
@media (max-width: 992px) {
  .table-container.responsive {
    overflow-x: auto;
  }
}
.table-container.full-width {
  width: 100%;
  max-width: 100%;
}
.table-container .table-header {
  padding: 1.25rem 1.5rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid var(--m-border, #eee);
  background: var(--m-card-background-color, white);
  position: relative;
  z-index: 0;
}
.table-container .table-header h2 {
  margin: 0;
  font-size: 1.125rem;
  font-weight: 600;
  color: var(--m-text, #2d3748);
  display: flex;
  align-items: center;
  gap: 0.75rem;
}
.table-container .table-header h2::after {
  content: "";
  display: block;
  width: 1px;
  height: 24px;
  background: #e2e8f0;
  margin-left: 0.25rem;
}
.table-container .table-header .table-actions {
  display: flex;
  gap: 0.75rem;
  align-items: center;
  flex-wrap: wrap;
  flex-shrink: 0;
}
.table-container .table-header .table-actions input {
  padding: 0.625rem 1rem;
  border: 1px solid var(--m-border, #e2e8f0);
  border-radius: 6px;
  min-width: 240px;
  font-size: 0.875rem;
  color: var(--m-text, #4a5568);
  background-color: var(--m-surface-subtle, #f8fafc);
  transition: all 0.2s ease;
}
.table-container .table-header .table-actions input::placeholder {
  color: var(--m-text-light, #a0aec0);
}
.table-container .table-header .table-actions input:hover {
  border-color: var(--m-border-hover, #cbd5e0);
  background-color: var(--m-card-background-color, white);
}
.table-container .table-header .table-actions input:focus {
  outline: none;
  border-color: var(--bs-primary);
  background-color: var(--m-card-background-color, white);
  box-shadow: 0 0 0 3px rgba(var(--bs-primary-rgb), 0.1);
}
.table-container .table-header .table-toolbar-actions {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  flex-shrink: 0;
  margin-left: auto;
}
.table-container .table-header .table-toolbar-actions .dropdown {
  width: auto;
}
@media (max-width: 768px) {
  .table-container .table-header {
    padding: 1rem;
    flex-direction: column;
    gap: 1rem;
    align-items: stretch;
  }
  .table-container .table-header h2::after {
    display: none;
  }
  .table-container .table-header .table-actions {
    width: 100%;
    flex: none;
  }
  .table-container .table-header .table-actions input {
    width: 100%;
  }
  .table-container .table-header .table-toolbar-actions {
    margin-left: 0;
    width: 100%;
  }
}
.table-container .table-wrapper {
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  position: relative;
  z-index: 0;
}
@media (max-width: 992px) {
  .table-container .table-wrapper {
    min-width: 100%;
  }
}
.table-container .content-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  position: relative;
  z-index: 0;
}
@media (max-width: 992px) {
  .table-container .content-table.table-responsive {
    min-width: 900px;
  }
}
.table-container .content-table#device-list, .table-container .content-table#model-list {
  width: 100%;
}
.table-container .content-table#device-list th:nth-child(1),
.table-container .content-table#device-list td:nth-child(1), .table-container .content-table#model-list th:nth-child(1),
.table-container .content-table#model-list td:nth-child(1) {
  min-width: 100px;
}
.table-container .content-table#device-list th:nth-child(2),
.table-container .content-table#device-list td:nth-child(2), .table-container .content-table#model-list th:nth-child(2),
.table-container .content-table#model-list td:nth-child(2) {
  min-width: 100px;
}
.table-container .content-table#device-list th:nth-child(3),
.table-container .content-table#device-list td:nth-child(3), .table-container .content-table#model-list th:nth-child(3),
.table-container .content-table#model-list td:nth-child(3) {
  min-width: 100px;
}
.table-container .content-table#device-list th:nth-child(4),
.table-container .content-table#device-list td:nth-child(4), .table-container .content-table#model-list th:nth-child(4),
.table-container .content-table#model-list td:nth-child(4) {
  min-width: 100px;
}
.table-container .content-table#device-list th:last-child,
.table-container .content-table#device-list td:last-child, .table-container .content-table#model-list th:last-child,
.table-container .content-table#model-list td:last-child {
  min-width: 100px;
  text-align: center;
}
.table-container .content-table th,
.table-container .content-table td {
  padding: 1rem;
  text-align: left;
  border-bottom: 1px solid var(--m-border, #eee);
  white-space: nowrap;
  position: relative;
  z-index: 0;
}
.table-container .content-table th:first-child,
.table-container .content-table td:first-child {
  padding-left: 1.5rem;
}
.table-container .content-table th:last-child,
.table-container .content-table td:last-child {
  padding-right: 1.5rem;
}
.table-container .content-table th {
  background: var(--m-card-background-color, #ffffff);
  font-weight: 600;
  color: var(--m-text, #212924);
  position: sticky;
  top: 0;
  z-index: 0;
  padding: 0;
  position: relative;
  border-bottom: 2px solid #00b4f3;
  font-size: 0.8rem;
  letter-spacing: 0.025em;
  text-transform: capitalize;
}
.table-container .content-table th.sortable {
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}
.table-container .content-table th.resizing {
  cursor: col-resize !important;
  -webkit-user-select: none;
          user-select: none;
}
.table-container .content-table th.resizing .th-content {
  background-color: rgba(var(--bs-primary-rgb), 0.05);
}
.table-container .content-table th.resizing .resizer {
  opacity: 1;
  background: var(--bs-primary);
}
.table-container .content-table th .th-content {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.875rem 1rem;
  width: 100%;
  height: 100%;
  transition: all 0.2s ease;
}
.table-container .content-table th .th-content:hover {
  background-color: rgba(var(--bs-primary-rgb), 0.05);
  color: var(--bs-primary);
}
.table-container .content-table th .th-content:hover .sort-icons {
  opacity: 1;
}
.table-container .content-table th .th-content .sort-icons {
  display: flex;
  flex-direction: column;
  margin-left: auto;
  height: 20px;
  opacity: 0.4;
  transition: opacity 0.2s ease;
}
.table-container .content-table th .th-content .sort-icons .sort-icon {
  font-size: 14px;
  color: currentColor;
  transition: all 0.2s ease;
  margin: -2px 0;
}
.table-container .content-table th .th-content .sort-icons .sort-icon.active {
  color: var(--bs-primary);
  opacity: 1;
  transform: scale(1.1);
}
.table-container .content-table th .th-content:first-child {
  padding-left: 1.5rem;
}
.table-container .content-table th .th-content:last-child {
  padding-right: 1.5rem;
}
.table-container .content-table th .resizer {
  position: absolute;
  right: -3px;
  top: 0;
  height: 100%;
  width: 6px;
  background: rgba(var(--bs-primary-rgb), 0.2);
  cursor: col-resize;
  -webkit-user-select: none;
          user-select: none;
  touch-action: none;
  opacity: 0;
  transition: all 0.2s ease;
  z-index: 1;
}
.table-container .content-table th .resizer:hover, .table-container .content-table th .resizer.resizing {
  background: var(--bs-primary);
  opacity: 1;
  box-shadow: 0 0 0 1px var(--bs-primary);
}
.table-container .content-table th:hover .resizer {
  opacity: 0.4;
}
.table-container .content-table td {
  color: var(--m-text, #212529);
  position: relative;
  z-index: 0;
}
.table-container .content-table tbody {
  position: relative;
  z-index: 0;
}
.table-container .content-table tbody tr {
  position: relative;
  z-index: 0;
}
.table-container .content-table tbody tr:hover {
  background-color: var(--m-surface-subtle, #f8f9fa);
}
.table-container .content-table tbody tr:last-child td {
  border-bottom: none;
}
.table-container .content-table tbody .loading-cell,
.table-container .content-table tbody .empty-cell {
  text-align: center;
  padding: 2rem;
  color: #6c757d;
}
.table-container .content-table.resizing {
  cursor: col-resize;
  -webkit-user-select: none;
          user-select: none;
}
.table-container .content-table.resizing * {
  cursor: col-resize;
  -webkit-user-select: none;
          user-select: none;
}
.table-container .pagination-container {
  padding: 1rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-top: 1px solid var(--m-border, #eee);
  background: var(--m-card-background-color, white);
  position: relative;
  z-index: 0;
}
.table-container .pagination-container .pagination-info {
  display: flex;
  align-items: center;
  gap: 1rem;
  color: var(--m-text, #495057);
}
.table-container .pagination-container .pagination-info select {
  padding: 0.375rem 1.75rem 0.375rem 0.75rem;
  font-size: 0.875rem;
  border: 1px solid var(--m-border, #ced4da);
  border-radius: 4px;
  background-color: var(--m-card-background-color, #fff);
  color: var(--m-text);
  cursor: pointer;
}
.table-container .pagination-container .pagination-info select:focus {
  outline: none;
  border-color: var(--bs-primary);
}
.table-container .pagination-container .pagination-actions {
  display: flex;
  gap: 0.5rem;
}
.table-container .pagination-container .pagination-actions button {
  padding: 0.375rem 0.75rem;
  border: 1px solid var(--m-border, #ced4da);
  background: var(--m-card-background-color, white);
  border-radius: 4px;
  cursor: pointer;
  color: var(--m-text, #495057);
  min-width: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.table-container .pagination-container .pagination-actions button:hover:not(:disabled) {
  background: var(--m-surface-subtle, #f8f9fa);
  border-color: var(--m-border, #adb5bd);
}
.table-container .pagination-container .pagination-actions button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.table-container .pagination-container .pagination-actions button:focus {
  outline: none;
  border-color: var(--bs-primary);
}
@media (max-width: 768px) {
  .table-container .pagination-container {
    flex-direction: column;
    gap: 1rem;
    align-items: stretch;
  }
  .table-container .pagination-container .pagination-info {
    flex-direction: column;
    align-items: center;
    text-align: center;
  }
  .table-container .pagination-container .pagination-actions {
    justify-content: center;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/BaseUI/Table/table.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,iDAAA;EACA,kBAAA;EACA,6DAAA;EACA,gBAAA;EACA,kBAAA;EACA,UAAA;AACF;AAEI;EADF;IAEI,gBAAA;EACJ;AACF;AAEE;EACE,WAAA;EACA,eAAA;AAAJ;AAIE;EACE,uBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,8CAAA;EACA,iDAAA;EACA,kBAAA;EACA,UAAA;AAFJ;AAII;EACE,SAAA;EACA,mBAAA;EACA,gBAAA;EACA,6BAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;AAFN;AAIM;EACE,WAAA;EACA,cAAA;EACA,UAAA;EACA,YAAA;EACA,mBAAA;EACA,oBAAA;AAFR;AAMI;EACE,aAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;EACA,cAAA;AAJN;AAMM;EACE,sBAAA;EACA,0CAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,6BAAA;EACA,kDAAA;EACA,yBAAA;AAJR;AAMQ;EACE,mCAAA;AAJV;AAOQ;EACE,4CAAA;EACA,uDAAA;AALV;AAQQ;EACE,aAAA;EACA,+BAAA;EACA,uDAAA;EACA,sDAAA;AANV;AAWI;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,cAAA;EACA,iBAAA;AATN;AAWM;EACE,WAAA;AATR;AAaI;EA5EF;IA6EI,aAAA;IACA,sBAAA;IACA,SAAA;IACA,oBAAA;EAVJ;EAaM;IACE,aAAA;EAXR;EAeI;IACE,WAAA;IACA,UAAA;EAbN;EAeM;IACE,WAAA;EAbR;EAiBI;IACE,cAAA;IACA,WAAA;EAfN;AACF;AAoBE;EACE,WAAA;EACA,gBAAA;EACA,iCAAA;EACA,kBAAA;EACA,UAAA;AAlBJ;AAoBI;EAPF;IAQI,eAAA;EAjBJ;AACF;AAqBE;EACE,WAAA;EACA,yBAAA;EACA,iBAAA;EACA,kBAAA;EACA,UAAA;AAnBJ;AAsBM;EADF;IAEI,gBAAA;EAnBN;AACF;AAuBI;EAEE,WAAA;AAtBN;AA0BQ;;;EAEE,gBAAA;AAvBV;AAyBQ;;;EAEE,gBAAA;AAtBV;AAwBQ;;;EAEE,gBAAA;AArBV;AAuBQ;;;EAEE,gBAAA;AApBV;AAsBQ;;;EAEE,gBAAA;EACA,kBAAA;AAnBV;AAwBI;;EAEE,aAAA;EACA,gBAAA;EACA,8CAAA;EACA,mBAAA;EACA,kBAAA;EACA,UAAA;AAtBN;AAwBM;;EACE,oBAAA;AArBR;AAwBM;;EACE,qBAAA;AArBR;AAyBI;EACE,mDAAA;EACA,gBAAA;EACA,6BAAA;EACA,gBAAA;EACA,MAAA;EACA,UAAA;EACA,UAAA;EACA,kBAAA;EACA,gCAAA;EACA,iBAAA;EACA,uBAAA;EACA,0BAAA;AAvBN;AAyBM;EACE,eAAA;EACA,yBAAA;UAAA,iBAAA;AAvBR;AA0BM;EACE,6BAAA;EACA,yBAAA;UAAA,iBAAA;AAxBR;AA0BQ;EACE,mDAAA;AAxBV;AA2BQ;EACE,UAAA;EACA,6BAAA;AAzBV;AA6BM;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;AA3BR;AA6BQ;EACE,mDAAA;EACA,wBAAA;AA3BV;AA6BU;EACE,UAAA;AA3BZ;AA+BQ;EACE,aAAA;EACA,sBAAA;EACA,iBAAA;EACA,YAAA;EACA,YAAA;EACA,6BAAA;AA7BV;AA+BU;EACE,eAAA;EACA,mBAAA;EACA,yBAAA;EACA,cAAA;AA7BZ;AA+BY;EACE,wBAAA;EACA,UAAA;EACA,qBAAA;AA7Bd;AAkCQ;EACE,oBAAA;AAhCV;AAmCQ;EACE,qBAAA;AAjCV;AAsCM;EACE,kBAAA;EACA,WAAA;EACA,MAAA;EACA,YAAA;EACA,UAAA;EACA,4CAAA;EACA,kBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,kBAAA;EACA,UAAA;EACA,yBAAA;EACA,UAAA;AApCR;AAsCQ;EAEE,6BAAA;EACA,UAAA;EACA,uCAAA;AArCV;AAyCM;EACE,YAAA;AAvCR;AA2CI;EACE,6BAAA;EACA,kBAAA;EACA,UAAA;AAzCN;AA4CI;EACE,kBAAA;EACA,UAAA;AA1CN;AA4CM;EACE,kBAAA;EACA,UAAA;AA1CR;AA4CQ;EACE,kDAAA;AA1CV;AA6CQ;EACE,mBAAA;AA3CV;AA+CM;;EAEE,kBAAA;EACA,aAAA;EACA,cAAA;AA7CR;AAkDI;EACE,kBAAA;EACA,yBAAA;UAAA,iBAAA;AAhDN;AAkDM;EACE,kBAAA;EACA,yBAAA;UAAA,iBAAA;AAhDR;AAsDE;EACE,aAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,2CAAA;EACA,iDAAA;EACA,kBAAA;EACA,UAAA;AApDJ;AAsDI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,6BAAA;AApDN;AAsDM;EACE,0CAAA;EACA,mBAAA;EACA,0CAAA;EACA,kBAAA;EACA,sDAAA;EACA,oBAAA;EACA,eAAA;AApDR;AAsDQ;EACE,aAAA;EACA,+BAAA;AApDV;AAyDI;EACE,aAAA;EACA,WAAA;AAvDN;AAyDM;EACE,yBAAA;EACA,0CAAA;EACA,iDAAA;EACA,kBAAA;EACA,eAAA;EACA,6BAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAvDR;AAyDQ;EACE,4CAAA;EACA,sCAAA;AAvDV;AA0DQ;EACE,YAAA;EACA,mBAAA;AAxDV;AA2DQ;EACE,aAAA;EACA,+BAAA;AAzDV;AA8DI;EAjEF;IAkEI,sBAAA;IACA,SAAA;IACA,oBAAA;EA3DJ;EA6DI;IACE,sBAAA;IACA,mBAAA;IACA,kBAAA;EA3DN;EA8DI;IACE,uBAAA;EA5DN;AACF","sourcesContent":[".table-container {\n  width: 100%;\n  background: var(--m-card-background-color, white);\n  border-radius: 8px;\n  box-shadow: var(--m-box-shadow, 0 1px 3px rgba(0, 0, 0, 0.1));\n  overflow: hidden;\n  position: relative;\n  z-index: 0;\n\n  &.responsive {\n    @media (max-width: 992px) {\n      overflow-x: auto;\n    }\n  }\n\n  &.full-width {\n    width: 100%;\n    max-width: 100%;\n  }\n\n  // Başlık ve arama bölümü\n  .table-header {\n    padding: 1.25rem 1.5rem;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    border-bottom: 1px solid var(--m-border, #eee);\n    background: var(--m-card-background-color, white);\n    position: relative;\n    z-index: 0;\n\n    h2 {\n      margin: 0;\n      font-size: 1.125rem;\n      font-weight: 600;\n      color: var(--m-text, #2d3748);\n      display: flex;\n      align-items: center;\n      gap: 0.75rem;\n\n      &::after {\n        content: \"\";\n        display: block;\n        width: 1px;\n        height: 24px;\n        background: #e2e8f0;\n        margin-left: 0.25rem;\n      }\n    }\n\n    .table-actions {\n      display: flex;\n      gap: 0.75rem;\n      align-items: center;\n      flex-wrap: wrap;\n      flex-shrink: 0;\n\n      input {\n        padding: 0.625rem 1rem;\n        border: 1px solid var(--m-border, #e2e8f0);\n        border-radius: 6px;\n        min-width: 240px;\n        font-size: 0.875rem;\n        color: var(--m-text, #4a5568);\n        background-color: var(--m-surface-subtle, #f8fafc);\n        transition: all 0.2s ease;\n\n        &::placeholder {\n          color: var(--m-text-light, #a0aec0);\n        }\n\n        &:hover {\n          border-color: var(--m-border-hover, #cbd5e0);\n          background-color: var(--m-card-background-color, white);\n        }\n\n        &:focus {\n          outline: none;\n          border-color: var(--bs-primary);\n          background-color: var(--m-card-background-color, white);\n          box-shadow: 0 0 0 3px rgba(var(--bs-primary-rgb), 0.1);\n        }\n      }\n    }\n\n    .table-toolbar-actions {\n      display: flex;\n      align-items: center;\n      gap: 0.75rem;\n      flex-shrink: 0;\n      margin-left: auto;\n\n      .dropdown {\n        width: auto;\n      }\n    }\n\n    @media (max-width: 768px) {\n      padding: 1rem;\n      flex-direction: column;\n      gap: 1rem;\n      align-items: stretch;\n\n      h2 {\n        &::after {\n          display: none;\n        }\n      }\n\n      .table-actions {\n        width: 100%;\n        flex: none;\n\n        input {\n          width: 100%;\n        }\n      }\n\n      .table-toolbar-actions {\n        margin-left: 0;\n        width: 100%;\n      }\n    }\n  }\n\n  // Tablo wrapper\n  .table-wrapper {\n    width: 100%;\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n    position: relative;\n    z-index: 0;\n\n    @media (max-width: 992px) {\n      min-width: 100%;\n    }\n  }\n\n  // Tablo\n  .content-table {\n    width: 100%;\n    border-collapse: separate;\n    border-spacing: 0;\n    position: relative;\n    z-index: 0;\n\n    &.table-responsive {\n      @media (max-width: 992px) {\n        min-width: 900px; // Ensure tables have a minimum width on small screens\n      }\n    }\n\n    // Device monitor and device models specific styling\n    &#device-list,\n    &#model-list {\n      width: 100%;\n\n      th,\n      td {\n        &:nth-child(1) {\n          // Serial/Code column\n          min-width: 100px;\n        }\n        &:nth-child(2) {\n          // Model column\n          min-width: 100px;\n        }\n        &:nth-child(3) {\n          // Company/Manufacturer column\n          min-width: 100px;\n        }\n        &:nth-child(4) {\n          // Status column\n          min-width: 100px;\n        }\n        &:last-child {\n          // Actions column\n          min-width: 100px;\n          text-align: center;\n        }\n      }\n    }\n\n    th,\n    td {\n      padding: 1rem;\n      text-align: left;\n      border-bottom: 1px solid var(--m-border, #eee);\n      white-space: nowrap;\n      position: relative;\n      z-index: 0;\n\n      &:first-child {\n        padding-left: 1.5rem;\n      }\n\n      &:last-child {\n        padding-right: 1.5rem;\n      }\n    }\n\n    th {\n      background: var(--m-card-background-color, #ffffff);\n      font-weight: 600;\n      color: var(--m-text, #212924);\n      position: sticky;\n      top: 0;\n      z-index: 0;\n      padding: 0;\n      position: relative;\n      border-bottom: 2px solid #00b4f3;\n      font-size: 0.8rem;\n      letter-spacing: 0.025em;\n      text-transform: capitalize;\n\n      &.sortable {\n        cursor: pointer;\n        user-select: none;\n      }\n\n      &.resizing {\n        cursor: col-resize !important;\n        user-select: none;\n\n        .th-content {\n          background-color: rgba(var(--bs-primary-rgb), 0.05);\n        }\n\n        .resizer {\n          opacity: 1;\n          background: var(--bs-primary);\n        }\n      }\n\n      .th-content {\n        display: flex;\n        align-items: center;\n        gap: 0.5rem;\n        padding: 0.875rem 1rem;\n        width: 100%;\n        height: 100%;\n        transition: all 0.2s ease;\n\n        &:hover {\n          background-color: rgba(var(--bs-primary-rgb), 0.05);\n          color: var(--bs-primary);\n\n          .sort-icons {\n            opacity: 1;\n          }\n        }\n\n        .sort-icons {\n          display: flex;\n          flex-direction: column;\n          margin-left: auto;\n          height: 20px;\n          opacity: 0.4;\n          transition: opacity 0.2s ease;\n\n          .sort-icon {\n            font-size: 14px;\n            color: currentColor;\n            transition: all 0.2s ease;\n            margin: -2px 0;\n\n            &.active {\n              color: var(--bs-primary);\n              opacity: 1;\n              transform: scale(1.1);\n            }\n          }\n        }\n\n        &:first-child {\n          padding-left: 1.5rem;\n        }\n\n        &:last-child {\n          padding-right: 1.5rem;\n        }\n      }\n\n      // Yeniden boyutlandırma tutamacı\n      .resizer {\n        position: absolute;\n        right: -3px;\n        top: 0;\n        height: 100%;\n        width: 6px;\n        background: rgba(var(--bs-primary-rgb), 0.2);\n        cursor: col-resize;\n        user-select: none;\n        touch-action: none;\n        opacity: 0;\n        transition: all 0.2s ease;\n        z-index: 1;\n\n        &:hover,\n        &.resizing {\n          background: var(--bs-primary);\n          opacity: 1;\n          box-shadow: 0 0 0 1px var(--bs-primary);\n        }\n      }\n\n      &:hover .resizer {\n        opacity: 0.4;\n      }\n    }\n\n    td {\n      color: var(--m-text, #212529);\n      position: relative;\n      z-index: 0;\n    }\n\n    tbody {\n      position: relative;\n      z-index: 0;\n\n      tr {\n        position: relative;\n        z-index: 0;\n\n        &:hover {\n          background-color: var(--m-surface-subtle, #f8f9fa);\n        }\n\n        &:last-child td {\n          border-bottom: none;\n        }\n      }\n\n      .loading-cell,\n      .empty-cell {\n        text-align: center;\n        padding: 2rem;\n        color: #6c757d;\n      }\n    }\n\n    // Yeniden boyutlandırma sırasında seçimi engelle\n    &.resizing {\n      cursor: col-resize;\n      user-select: none;\n\n      * {\n        cursor: col-resize;\n        user-select: none;\n      }\n    }\n  }\n\n  // Sayfalama\n  .pagination-container {\n    padding: 1rem;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    border-top: 1px solid var(--m-border, #eee);\n    background: var(--m-card-background-color, white);\n    position: relative;\n    z-index: 0;\n\n    .pagination-info {\n      display: flex;\n      align-items: center;\n      gap: 1rem;\n      color: var(--m-text, #495057);\n\n      select {\n        padding: 0.375rem 1.75rem 0.375rem 0.75rem;\n        font-size: 0.875rem;\n        border: 1px solid var(--m-border, #ced4da);\n        border-radius: 4px;\n        background-color: var(--m-card-background-color, #fff);\n        color: var(--m-text);\n        cursor: pointer;\n\n        &:focus {\n          outline: none;\n          border-color: var(--bs-primary);\n        }\n      }\n    }\n\n    .pagination-actions {\n      display: flex;\n      gap: 0.5rem;\n\n      button {\n        padding: 0.375rem 0.75rem;\n        border: 1px solid var(--m-border, #ced4da);\n        background: var(--m-card-background-color, white);\n        border-radius: 4px;\n        cursor: pointer;\n        color: var(--m-text, #495057);\n        min-width: 36px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n\n        &:hover:not(:disabled) {\n          background: var(--m-surface-subtle, #f8f9fa);\n          border-color: var(--m-border, #adb5bd);\n        }\n\n        &:disabled {\n          opacity: 0.5;\n          cursor: not-allowed;\n        }\n\n        &:focus {\n          outline: none;\n          border-color: var(--bs-primary);\n        }\n      }\n    }\n\n    @media (max-width: 768px) {\n      flex-direction: column;\n      gap: 1rem;\n      align-items: stretch;\n\n      .pagination-info {\n        flex-direction: column;\n        align-items: center;\n        text-align: center;\n      }\n\n      .pagination-actions {\n        justify-content: center;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
